import React from 'react';

const StackSquareIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.6641 5.41667H3.33073M14.9974 2.5H4.9974M18.3307 8.33333V17.5H1.66406V8.33333H18.3307Z'
        stroke='#6B7280'
        strokeWidth='1.2'
        strokeLinecap='square'
      />
    </svg>
  );
};

export default StackSquareIcon;
